import { app } from '../../../../app';
import { Controller } from './mobile-app-support-form.controller';

app.component('mobileApplicationSettingsForm', {
    bindings: {
        mobileApplicationSettings: '<',
        onChange: '&',
        onEnter: '&',
    },
    controller: Controller,
    templateUrl: require('./mobile-app-support-form.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/mobile-app-support/mobile-app-support-form.component.js